angular.module('core')
    .service('dblMathService', [function() {

        /**
         * Return ordinal for non-negative numeric value n.
         *
         **/
        function getOrdinal (n) {
            if (isNaN(parseInt(n)) || n < 0) {
                return '';
            }

            // 11, 12, 13 mod 100 are special cases
            var nMod100 = n % 100;
            if (nMod100 > 10 && nMod100 < 14) {
                return n + 'th';
            }

            switch (n % 10) {
                case 1: return n + 'st';
                case 2: return n + 'nd';
                case 3: return n + 'rd';
                default: return n + 'th';
            }
        }

        return {
            getOrdinal: getOrdinal
        };
    }]
);
